import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getOneUser } from '../../../redux/User/actions';
import ShowUser from '../Users/ShowUser';

const ShowMachineUserDetails = ({ userId }) => {
  const dispatch = useDispatch();
  const [user, setUser] = useState(null);

  const userDetails = useSelector((state) => state.Users?.selectedUser || null);
  const error = useSelector((state) => state.Users?.error || null);

  // Fetch user details when the component mounts or userId changes
  useEffect(() => {
    if (userId) {
      dispatch(getOneUser(userId));
    } else {
      setUser(null); // Clear user data if userId is null
    }
  }, [dispatch, userId]);

  // Update the local state when userDetails changes
  useEffect(() => {
    if (userDetails && userDetails._id === userId) {
      setUser(userDetails);
    }
  }, [userDetails, userId]);

  // Render the component
  return (
    <div>
      {error ? (
        <p>Error fetching user details: {error}</p>
      ) : (
        user ? <ShowUser item={user} logo={'userInfo'} /> : <p>N/A</p>
      )}
    </div>
  );
};

export default ShowMachineUserDetails;
